import React, { memo, useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import { Avatar, Comment, Pagination, Tooltip } from 'antd'
import { CellEclipseBox } from '../../../components/Common/Table'
import AdvanceFilterBlock from './AdvanceFilterBlock'
import { apiUrl } from '../../../config'
import TableComponent from '../../../components/Common/TableComponent'
import { EmptyText } from '../../../components/Common/CellText'
import { useMediaQuery } from 'react-responsive'

const ListUserPage = props => {
  const { userStore, loadingAnimationStore, positionStore, departmentStore } = props

  const {
    userList,
    userListTotalCount,
    userListPageSize,
    userListPageIndex,
    setFilter,
  } = userStore
  const { positionList } = positionStore
  const { departmentList } = departmentStore
  const isWideScreen = useMediaQuery({ query: '(min-width: 1281px)' })
  useEffect(() => {
    positionStore.getPositionList()
    departmentStore.getDepartmentList()
  }, [])
  function convertCodeOrCodesToName(input) {
    const codes = input?.split(',').map(code => code.trim())
    const names = codes?.map(code => {
      const role = positionList?.find(role => role.code === code)
      return role ? role?.name : 'Không tìm thấy chức danh'
    })
    return names?.join(', ')
  }

  function convertCodeOrCodesToDepartName(input) {
    const codes = input?.split(',').map(code => code.trim())
    const names = codes?.map(code => {
      const role = departmentList?.find(role => role.code === code)
      return role ? role?.name : 'Không tìm thấy phòng ban'
    })
    return names?.join(', ')
  }
  const onChangePagination = e => {
    setFilter('userListPageIndex', e - 1)
    loadingAnimationStore.setTableLoading(true)
    userStore
      .getUserList()
      .finally(() => loadingAnimationStore.setTableLoading(false))
  }

  const tableColumn = [
    {
      title: 'Thông tin',
      render: record => (
        <Comment
          author={
            <span style={{ textTransform: 'capitalize' }}>
              {record.name_lowercase}
            </span>
          }
          avatar={
            <Avatar
              style={{ backgroundColor: '#1890ff' }}
              src={
                record?.imageId && `${apiUrl}/api/v1/images/${record?.imageId}`
              }>
              {record?.name_uppercase?.split('')[0].toString().toUpperCase()}
            </Avatar>
          }
        />
      ),
      width: 10,
    },
    {
      title: 'ID',
      width: 10,
      render: record => record?.username,
    },
    {
      title: 'Mã nhân viên',
      width: 10,
      render: record =>
        record?.ma_nv ? record?.ma_nv : <EmptyText>Không rõ</EmptyText>,
    },
    {
      title: 'Email',
      width: 10,
      render: record => (
        <Tooltip title={record?.email}>
          <CellEclipseBox>{record?.email}</CellEclipseBox>
        </Tooltip>
      ),
    },
    {
      title: 'Điện thoại',
      width: 10,
      render: record => (
        <strong>
          {record.phone ? record?.phone : <EmptyText>Chưa rõ</EmptyText>}
        </strong>
      ),
    },
    // ...(isWideScreen
    //   ? [
    {
      title: 'Số máy nội bộ',
      width: 10,
      render: record => (
        <strong>
          {record.home_phone ? (
            record?.home_phone
          ) : (
            <EmptyText>Chưa rõ</EmptyText>
          )}
        </strong>
      ),
    },
    {
      title: 'Địa chỉ',
      width: 10,
      render: record =>
        record.address ? record?.address : <EmptyText>Chưa rõ</EmptyText>,
    },
    //   ]
    // : []),
    {
      title: 'Chức vụ',
      width: 10,
      render: record => (
        <Tooltip
          title={
            record.position
              ? convertCodeOrCodesToName(record.position.code)
              : ''
          }>
          <div
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '100px',
            }}>
            {record.position
              ? convertCodeOrCodesToName(record.position.code)
              : ''}
          </div>
        </Tooltip>
      ),
    },
    {
      title: 'Phòng ban',
      width: 10,
      fixed: 'right',
      render: record => (
        <Tooltip title={convertCodeOrCodesToDepartName(record?.department?.code)}>
          <CellEclipseBox>{convertCodeOrCodesToDepartName(record?.department?.code)}</CellEclipseBox>
        </Tooltip>
      ),
    },
  ]

  return (
    <>
      <AdvanceFilterBlock />
      <TableComponent
        rowKey={record => record.code}
        columns={tableColumn}
        dataSource={userList}
        pagination={false}
        loading={loadingAnimationStore.tableLoading}
        scroll={{ x: 1180 }}
      />
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          padding: '15px 0',
        }}>
        <Pagination
          onChange={e => onChangePagination(e)}
          hideOnSinglePage={true}
          total={userListTotalCount}
          pageSize={userListPageSize}
          current={userListPageIndex + 1}
          showSizeChanger={false}
          showLessItems
        />
      </div>
    </>
  )
}

ListUserPage.propTypes = {}

export default memo(
  inject(
    'userStore',
    'loadingAnimationStore',
    'positionStore',
    'departmentStore'
  )(observer(ListUserPage))
)
